


























import { Component, Vue, Prop } from 'vue-property-decorator';
import ChevronIcon from 'mdi-vue/ChevronRight';

@Component({
  components: {
    ChevronIcon,
  },
})
export default class Accordion extends Vue {
  @Prop(String) image!: string;
  @Prop(String) label!: string;
  @Prop(String) number!: string;
  @Prop(String) subLabel!: string;
  @Prop(Boolean) noPadding!: boolean;
  @Prop({ default: 'default' }) readonly variant!: string;

  active = false;
  prevHeight = '0';

  $refs!: {
    content: HTMLDivElement;
  }

  onTransitionEnd() {
    const panel = this.$refs.content;
    if (this.active) {
      panel.style.maxHeight = 'initial';
    }
  }

  getImage() {
    const images = require.context('@/assets/logo', false, /\.png$/);
    return images(`./${this.image}`);
  }

  toggle() {
    this.active = !this.active;

    const panel = this.$refs.content;
    panel.ontransitionend = this.onTransitionEnd;
    if (this.active) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    } else {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      setTimeout(() => {
        panel.style.maxHeight = '0';
      }, 1);
    }
  }
}
